import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as i18next from 'i18next';
import CoachSchemaComponent from './coach-schema';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component({
    components: {
        'v-coach-schema': CoachSchemaComponent
    }
})
export class TrainCoachPlaceSelectComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    focusedTrainNumber: string = '';
    selectedTrainNumber: string = '';
    focusedCoachNumber: string = '';
    focusedPlaceNumber: string = '';

    tooltipActivator: EventTarget | null = null;
    tooltipContent = '';

    svgSchema = '';
    svgSchemaLoading = false;

    mounted() {
        this.selectedTrainNumber = this.reservation?.trains[0]?.number ?? '';
    }

    get selectedTrain() {
        const selectedTrain = this.reservation.trains.find(train => train.number === this.selectedTrainNumber);

        if (selectedTrain) {
            return selectedTrain;
        }

        return undefined;
    }

    get selectedCoach() {
        const selectedCoach = this.selectedTrain?.selectedCoach;

        if (selectedCoach) {
            if (selectedCoach.schemaId) {
                this.svgSchemaLoading = true;

                const schema = this.reservation.trainCoaches[selectedCoach.schemaId];

                if (schema) {
                    this.svgSchema = schema;
                } else {
                    this.svgSchema = '';
                }

                this.svgSchemaLoading = false;
            } else {
                this.svgSchema = '';
            }
        }

        return selectedCoach;
    }

    getPlaceSelectionToBeDoneForTrainLabel(train: flights.TrainModel) {
        let toBeDoneCount = 0;

        if (train.selectedCoach) {
            toBeDoneCount = this.reservation.passengersWithSeatCount - train.selectedCoach.selectedPlacesCount;
        }

        return toBeDoneCount > 0
            ? i18next.t('numerous_seats_selection_to_be_done', <any>{ count: toBeDoneCount })
            : '';
    }

    onPlaceSelectionChange(place: flights.CoachPlaceModel) {
        if (this.selectedCoach) {
            if (this.selectedCoach.selectedPlacesCount > this.reservation.passengersWithSeatCount
                && this.selectedCoach.selectedPlacesQueue.length) {
                this.selectedCoach.selectedPlacesQueue[0].selected = false;
                this.selectedCoach.selectedPlacesQueue.shift();
            }

            if (place.selected) {
                this.selectedCoach.selectedPlacesQueue.push(place);
            }

            if (!place.selected) {
                this.selectedCoach.selectedPlacesQueue = this.selectedCoach.selectedPlacesQueue.filter(queuedPlace => queuedPlace.number != place.number);
            }
        }
    }

    onTrainFocus(number: string) {
        this.focusedTrainNumber = number;
    }

    onTrainBlur() {
        this.focusedTrainNumber = '';
    }

    onCoachFocus(number: string) {
        this.focusedCoachNumber = number;
    }

    onCoachBlur() {
        this.focusedCoachNumber = '';
    }

    onPlaceFocus(number: string) {
        this.focusedPlaceNumber = number;
    }

    onPlaceBlur() {
        this.focusedPlaceNumber = '';
    }

    onPlaceMouseEnter(event: Event, place: flights.CoachPlaceModel) {
        this.tooltipContent = `${i18next.t(`label_coach_place_${place.placeType.toLowerCase()}`)}, ${this.$options.filters?.price(place.fare.amount)}`;
        this.tooltipActivator = event.target;
        if (this.$refs['tooltip']) {
            this.$refs['tooltip']['isActive'] = true;
        }
    }

    onPlaceMouseLeave() {
        this.tooltipActivator = null;
        if (this.$refs['tooltip']) {
            this.$refs['tooltip']['isActive'] = false;
        }
    }

    onCoachSchemaShowTooltip(options: { tooltipContent: string; tooltipActivator: EventTarget }) {
        this.tooltipContent = options.tooltipContent;
        this.tooltipActivator = options.tooltipActivator;
        if (this.$refs['tooltip']) {
            this.$refs['tooltip']['isActive'] = true;
        }
    }

    onCoachSchemaHideTooltip() {
        this.tooltipActivator = null;
        if (this.$refs['tooltip']) {
            this.$refs['tooltip']['isActive'] = false;
        }
    }
}
